import PageHeader from "../PageHeader";
import { ReactComponent as LearnerIcon } from "../../images/learnersimage/learnericon.svg";
import useStyles from "../../../styles";
import { Report2Api } from "../../../service/services";
import { decryptData } from "../../../crypto";
import Loader from "../../CustomComponent/Loader";
import { useEffect, useState } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import ViewDailyDashBoardReport from "./ViewDailyDashBoardReport";
import {
  Button,
  FormLabel,
  IconButton,
  TextField,
  Tooltip,
} from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import CustomTableView from "../../CustomComponent/TableView";
import { ReactComponent as BackIcon } from "../../images/pageheadingicon/backicon.svg";


function DailyDashBoardReport() {
  const classes = useStyles();
  const [loaderOpen, setLoaderOpen] = useState(false);

  const [selectedExamDate, setSelectedExamDate] = useState("");
  const [exam, setExam] = useState([]);
  const [pageSize, setPageSize] = useState(25);
  const [onPage, setOnPage] = useState(0);
  const [page, setPage] = useState(0);
  const [rowCount, setRowCount] = useState("");

  const handleExamDateChange = (event) => {
    setSelectedExamDate(event.target.value);
  };

  const downloadCSV = (data) => {
    const headers = [
      "S.No",
      "Exam Code",
      "Exam Name",
      "Start Time",
      "End Time",
      "Paper Code",
      "Paper Uploading Status",
      "Paper Checking Status",
      "Result Created",
      "Result Generated",
    ];

    const rows = data.map((item, index) => [
      index + 1,
      item.exam_code,
      item.exam_name,
      `${item.start_date} ${item.start_time}`,
      `${item.start_date} ${item.end_time}`,
      item.paper_code || "-",
      item.question_uploaded,
      item.paper_check_status,
      item.created_result,
      item.genrate_result,
    ]);

    const csvContent = [headers, ...rows]
      .map((row) => row.map((val) => `"${val}"`).join(","))
      .join("\n");

    // Create blob
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

    // Create download link
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "daily_dashboad_report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleExportClick = async () => {
    if (!selectedExamDate) {
      toast.warning("Please select date");
      return;
    }
    setLoaderOpen(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/calendar/date?start_date=${selectedExamDate}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        },
      );

      if (response.data.success === false) {
        toast.warning(response.data.message || "Data not found");
        setLoaderOpen(false);
        return;
      }

      const exams = response.data.exams || [];

      if (exams.length === 0) {
        toast.warning("No data available");
        setLoaderOpen(false);
        return;
      }

      // 👉 call CSV download
      downloadCSV(exams);
      setLoaderOpen(false);
    } catch (error) {
      console.error("Error fetching data: ", error);
      toast.warning(error?.response?.data?.message || "Data not found");
      setLoaderOpen(false);
    }
  };

  const decryptedToken = decryptData(sessionStorage.getItem("token"));

  const Heading = [
    {
      id: 1,
      pageicon: <LearnerIcon />,
      mainheading: "Daily Dashboard Report",
      addbtntext: "Back",
      addbtnicon: <BackIcon />,
      addbtnstyle: "transparentbtn",
      path: "/admin/allreports",
    },
  ];

  const fetchData = async (date, pageNumber, size) => {
    setLoaderOpen(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/calendar/date?start_date=${date}&page=${pageNumber}&limit=${size}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        },
      );

      if (response.data.success === false) {
        setLoaderOpen(false);
        toast.warning(response.message || "data not found");
        return;
      }

      setExam(response.data.exams);
      setLoaderOpen(false);
    } catch (error) {
      console.error("Error fetching data: ", error);
      toast.warning(error.response.data.message || "data not found");
      setLoaderOpen(false);
    }
  };

  useEffect(() => {
    if (selectedExamDate) {
      fetchData(selectedExamDate, onPage, pageSize);
    }
  }, [selectedExamDate, onPage, pageSize]);

  const startIndex = onPage * pageSize;
  const rows = exam.map((d, i) => ({
    srno: startIndex + i + 1,
    id: d.id || startIndex + i, // unique id for DataGrid
    exam_code: d?.exam_code || "N/A",
    exam_name: d?.exam_name ? d?.exam_name : "N/A",
    start_time: d?.start_time ? d?.start_time : "N/A",
    end_time: d?.end_time ? d?.end_time : "N/A",
    paper_code: d?.paper_code ? d?.paper_code : "N/A",
    paper_uploading_status: d?.question_uploaded ? d?.question_uploaded : "N/A",
    paper_checking_status: d?.paper_check_status
      ? d?.paper_check_status
      : "N/A",
    result_created: d?.created_result ? d?.created_result : "N/A",
    result_generated: d?.genrate_result ? d?.genrate_result : "N/A",
    paper_check_status_details: d?.paper_check_status_details || null,
  }));

  const columns = [
    {
      field: "srno",
      headerName: "S.No",
      width: 70,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => params.row.srno,
    },
    {
      field: "exam_code",
      headerName: "Exam Code",
      width: 150,
      // flex: 0.8,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "exam_name",
      headerName: "Exam Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 300,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "start_time",
      headerName: "Start Time",
      width: 150,
      // flex: 0.8,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
    },

    {
      field: "end_time",
      headerName: "End Time",
      width: 150,
      // flex: 0.8,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "paper_code",
      headerName: "Paper Code",
      width: 140,
      // flex: 0.9,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      // renderCell: (params) => params.row.course_name || "N/A",
    },
    {
      field: "paper_uploading_status",
      headerName: "Paper Uploading Status",
      width: 140, // ✅ more base width
      // flex: 2.5, // ✅ takes more remaining space
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      // renderCell: (params) => params.row.batch_name || "N/A",
    },
    {
      field: "paper_checking_status",
      headerName: "Paper Checking Status",
      width: 180,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      sortable: false,
      disableColumnMenu: true,

      renderCell: (params) => {
        const status = params.row.paper_checking_status;
        const fullName = params.row.paper_check_status_details?.full_name;

        if (status === "yes") {
          return `${status} (${fullName})`;
        }

        return status || "-";
      },
    },

    {
      field: "result_created",
      headerName: "Result Created",
      width: 150,
      // flex: 0.6,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "result_generated",
      headerName: "Result Generated",
      width: 150,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
    },
  ];

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPage(0);
    setOnPage(0);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
    setOnPage(newPage);
  };

  const style = [
    {
      height: "h89vh",
      style: "viewtable",
      footer: false,
      checkboxselection: false,
      setPageSize: handlePageSizeChange,
      pageSize: pageSize,
      rowCount: rowCount,
      handlePageChange: handlePageChange,
      page: page,
      paginationMode: "server",
    },
  ];

  return (
    <div className={`${classes.p2} ${classes.pb0} ${classes.pt1}`}>
      <Loader loaderOpen={loaderOpen} />
      <PageHeader Heading={Heading} />
      <>
        <div
          className={`${classes.w100} ${classes.bgblue} ${classes.inputdropdowniconcolor}  ${classes.alignitemscenter}   ${classes.mt1} ${classes.borderradius6px}   ${classes.inputpadding} ${classes.inputborderwhite}  ${classes.inputplaceholdercolor}   ${classes.dflex}`}
        >
          <div className={`${classes.w100} ${classes.dflex}`}>
            <div
              className={`${classes.dflex}  ${classes.mx0_5} ${classes.flexdirectioncolumn} ${classes.w24} ${classes.my1}`}
            >
              <FormLabel
                className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} 
              ${classes.lineheight}`}
              ></FormLabel>

              <TextField
                type="date"
                variant="outlined"
                required
                className={`${classes.whiteCalendar}`}
                value={selectedExamDate}
                onChange={handleExamDateChange}
                placeholder="Select Date"
              />
            </div>

            {/* <Button
            variant="contained"
            color="primary"
            className={`${classes.transparentbtn} ${classes.mx0_5} ${classes.my1}`}
            onClick={handleApplyClick}
          >
            Apply
          </Button> */}
          </div>

          <Tooltip title="Export">
            <IconButton
              color="primary"
              className={`${classes.mx0_5}`}
              onClick={handleExportClick}
              style={{ color: "#fff" }}
            >
              <SaveIcon fontSize="large" />
            </IconButton>
          </Tooltip>

          <div style={{ padding: "10px" }}></div>
        </div>
      </>
      <CustomTableView columns={columns} rows={rows} Heading={style} />
      <ToastContainer />
    </div>
  );
}

export default DailyDashBoardReport;
